<template>
  <div id="pageRoot">
    <p class="textBase appearAnimationB" id="text01">
      Presta atención los siguientes enunciados.
    </p>
    <p class="textBase appearAnimationB" id="text02">
      Presta atención a las expresiones destacadas.
    </p>
    <p class="textBase appearAnimationB" id="text03">
      Marca la opción correcta.
    </p>
    <p class="textBase appearAnimationB" id="text04">Los seres humanos</p>

    <div class="hover-animation-c appearAnimationA" id="tag01">
      <p class="textBase" id="tag01Text">se desplazaban de un sitio a otro.</p>
    </div>

    <p class="textBase appearAnimationB" id="text05">Es lo mismo que decir:</p>

    <label
      class="toggleButtonContainer pageElement"
      id="toggle01"
      style="width: 360px"
      >Los seres humanos vivían<br />
      siempre en el mismo lugar.
      <input
        type="radio"
        name="pregunta"
        ref="1-1"
        v-on:change="saveOption('radios', 1, 1)"
        :onload="loadOption('radios', 1, 1)"
      />
      <span class="toggleButton"></span>
    </label>
    <label
      class="toggleButtonContainer pageElement"
      id="toggle02"
      style="width: 360px"
      >Los seres humanos se<br />
      trasladaban de un lugar a otro.
      <input
        type="radio"
        name="pregunta"
        ref="1-2"
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
      />
      <span class="toggleButton"></span>
    </label>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <div class="pageElement" id="fixed"></div>
    <span class="footer-page footer-listen"></span>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
#fixed {
  position: absolute;
  width: 791.66px;
  height: 196.97px;
  left: 36px;
  top: 50px;
  background-image: url(/pages/img/sordo/svgPage86FixedBackground.svg);
}
#text01 {
  position: absolute;
  width: 594px;
  height: 35px;
  left: 78px;
  top: 118px;

  font-size: 24px;
  line-height: 33px;

  color: #000000;
}
#text02 {
  position: absolute;
  width: 594px;
  height: 35px;
  left: 78px;
  top: 168px;

  font-size: 24px;
  line-height: 33px;

  color: #000000;
}
#text03 {
  position: absolute;
  width: 308px;
  height: 35px;
  left: 78px;
  top: 218px;

  font-size: 24px;
  line-height: 33px;

  color: #000000;
}
#text04 {
  position: absolute;
  width: 330px;
  height: 44px;
  left: 78px;
  top: 304px;

  font-style: italic;
  font-weight: normal;
  font-size: 32px;
  line-height: 45px;

  color: #000000;
}
#tag01 {
  position: absolute;
  width: 540px;
  height: 53px;
  left: 373px;
  top: 304px;
  background-color: #00a5a5;
}
#tag01Text {
  position: absolute;
  width: 520px;
  height: 44px;
  left: 13px;
  top: 0px;

  font-style: italic;
  font-weight: normal;
  font-size: 32px;
  line-height: 45px;

  color: #ffffff;
}
#text05 {
  position: absolute;
  width: 328px;
  height: 33px;
  left: 39px;
  top: 395px;

  font-size: 30px;
  line-height: 41px;

  color: #00a5a5;
}
#toggle01 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 372px;
  top: 396.86px;
}
#toggle02 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 372px;
  top: 514.86px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p86-88/V104.mp4",
        "p86-88/V105.mp4",
        "p86-88/V106.mp4",
        "p86-88/V107.mp4",
        "p87/V111.mp4",
        "p87/V112.mp4",
        "p87/V113.mp4",
      ],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>